import { IsOptional, IsString } from 'class-validator';
import { ApiPropertyOptional } from '@nestjs/swagger';

export class UpdateAttemptStatusDto {
  @ApiPropertyOptional({ description: 'Libellé', example: 'Soumise' })
  @IsOptional()
  @IsString()
  label?: string;
}








